/**--external-- */
import React from "react";
import { Translation } from "react-i18next";
import { WarningTriangleOutlined } from "@toddle-edu/ds-icons";

/**--internal-- */
import EmptyField from "UIComponents/EmptyField";
import UIBaseComponent from "UIComponents/UIBaseComponent";

/**--relative-- */
import classes from "./Field.scss";
import { emptyFieldContainerStyle, emptyFieldTitleStyle } from "./FieldStyles";

/**
 * Purpose of this component is to implement all field related operations/features.
 * Currently, it deals with field preview only. Later, we will move field locking, field label, field empty states from UIBaseComponent to this component.
 * In future, we might disconnect Field from UIBaseComponent.
 */
class Field extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  renderPreviewContent = () => {
    const { hideFieldContent } = this.props;

    if (hideFieldContent) {
      return null;
    }

    return (
      <Translation ns={["common"]}>
        {t => (
          <EmptyField
            title={t("common:no_preview_available")}
            containerStyle={emptyFieldContainerStyle}
            titleStyles={emptyFieldTitleStyle}
            renderIcon={
              <WarningTriangleOutlined size="x-small" variant="subtle" />
            }
          />
        )}
      </Translation>
    );
  };

  renderPreview = () => {
    return (
      <div className={classes.disabled}>{this.renderPreviewContent()}</div>
    );
  };
}

export default Field;

Field.defaultProps = {
  ...UIBaseComponent.defaultProps,
  hideFieldContent: false,
  fieldLockedObject: {},
};
